module.exports = __webpack_public_path__ + "img/29-General aging.f2501f9e.png";